module.exports = __webpack_public_path__ + "static/image/logo-l.5b59dc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-l.png
// module id = 377
// module chunks = 1